import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton } from '@mui/material';
import Iconify from '../../../../../components/iconify';
import ProtectedComponent from '../../../../../components/protected/ProtectedComponent';

const Actions = ({ row, onDeleteIconClick }) => {
  const isDeleteDisabled = Number(row.original?.consumedHours > 0);
  return (
    <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
      <ProtectedComponent permission={'DELETE_TASK'}>
        <IconButton
          disabled={isDeleteDisabled}
          onClick={(event) => {
            event.stopPropagation();
            onDeleteIconClick(row?.original);
          }}
        >
          <Iconify
            icon={'eva:trash-2-outline'}
            sx={{
              color: !isDeleteDisabled && 'error.main',
            }}
          />
        </IconButton>
      </ProtectedComponent>
    </Box>
  );
};

Actions.propTypes = {
  row: PropTypes.object.isRequired,
  onDeleteIconClick: PropTypes.func.isRequired,
};

export default Actions;
